import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { IntegrationPredefinedFields } from '@app/services/selective-processes/component/button-settings/integration-predefined-fields/integration-predefined-fields';
import { Fields } from '@app/services/selective-processes/fields/fields';
import { MyErrorStateMatcher } from '@modules/administration/portal/portal.component';
import { DataSourceTypeFieldValidator } from '@shared/validators/data-source-type-field-validator';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { FormCustomValidators } from '../adds-pareaments/adds-pareaments.component';

@Component({
  selector: 'app-fields-related-to-button-eduConnect-pay-integration',
  templateUrl: './fields-related-to-button-eduConnect-pay-integration.component.html',
  styleUrls: ['./fields-related-to-button-eduConnect-pay-integration.component.scss']
})
export class FieldsRelatedToButtonEduConnectPayIntegrationComponent implements OnInit {

  @Input() formGroup: FormGroup;
  @Input() controlForm: FormArray;
  @Input() systemFields: Fields[] = [];
  @Input() predefinedFieldsIntegration: IntegrationPredefinedFields[] = [];

  public matcher = new MyErrorStateMatcher();

  public filteredSystemFieldOptions: Observable<Fields[]>[] = [];

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.predefinedFieldsIntegration.map((value) => {
      this.controlForm.push(this.createItem(value));
      this.manageNameControl(this.controlForm.length - 1);
    });
  }

  createItem(eduConnectPayField): FormGroup {
    const hint = this.getHint(eduConnectPayField.edu_connect_pay_field_id);
    return this.formBuilder.group({
      id: eduConnectPayField.id ? eduConnectPayField.id : null,
      integration_edu_connect_pay_id: eduConnectPayField.integration_edu_connect_pay_id ? eduConnectPayField.integration_edu_connect_pay_id : null,
      title: eduConnectPayField.title,
      edu_connect_pay_field_id: eduConnectPayField.edu_connect_pay_field_id,
      is_required: eduConnectPayField.is_required,
      identifier: eduConnectPayField.identifier,
      field_type_id: eduConnectPayField.field_type_id,
      parameter_type_id: [
        eduConnectPayField.parameter_type_id ? eduConnectPayField.parameter_type_id : null,
        eduConnectPayField.is_required === 1 ? Validators.required : null
      ],
      field_id: [
        this.searchTheCompleteFieldData(eduConnectPayField.field_id ? eduConnectPayField.field_id : ''),
        this.setValidationWithFieldIdIfRequired(eduConnectPayField.is_required)
      ],
      fixed_value: [
        eduConnectPayField.fixed_value ? eduConnectPayField.fixed_value : '',
        this.setValidationWithFixedValueIfRequired(eduConnectPayField.is_required)
      ],
      field_hint: hint
    });
  }

  private setValidationWithFieldIdIfRequired(isRequired) {
    if (isRequired === 1) {
      return [DataSourceTypeFieldValidator.valueFieldId(), FormCustomValidators.valueSelected(this.systemFields)];
    }
    return [FormCustomValidators.valueSelected(this.systemFields)];
  }

  private setValidationWithFixedValueIfRequired(isRequired) {
    if (isRequired === 1) {
      return [DataSourceTypeFieldValidator.valueFixedValue()];
    }
    return [];
  }

  manageNameControl(index: number) {
    this.filteredSystemFieldOptions[index] = this.controlForm.at(index).get('field_id').valueChanges
      .pipe(
        startWith(''),
        map(option => option ? this.systemFieldOptionsFilter(option) : this.systemFields.slice())
      );
  }

  clear(formIndex) {
    this.controlForm.get(String(formIndex)).patchValue(
      {
        parameter_type_id: null,
        field_id: null,
        fixed_value: null
      }
    )
  }

  parameterTypeChanges() {
    this.controlForm.controls.forEach(control => {
      const controlAny: any = control;
      controlAny.controls.fixed_value.updateValueAndValidity();
      controlAny.controls.field_id.updateValueAndValidity();
    });
  }

  private searchTheCompleteFieldData(fieldId) {
    if (typeof fieldId !== 'object') {
      if (this.systemFields && this.systemFields.length) {
        for (const iterator of this.systemFields) {
          if (iterator.field_id === fieldId) {
            return iterator;
          }
        }
      }
      return null;
    }
    return fieldId;
  }

  systemFieldOptionsFilter(value: string): Fields[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.systemFields.filter(option =>
        option.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(filterValue)).sort((a, b) => {
          if (a.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') <
            b.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return -1;
          } else if (a.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') >
            b.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return 1;
          } else {
            return 0;
          }
        });
    }
    return [];
  }

  displayFn(field?: Fields): string | undefined {
    return field ? field.label : undefined;
  }

  getHint(eduConnectPayField) {
    let hint = '';
    switch (eduConnectPayField) {
      case 1:
        hint = 'CPF - 0 | RG - 1 | Usuário - 2 | Email – 3';
        break;
      case 10:
        hint = `
        O país deverá ser enviado em Código ISO (2 letras)
        exemplo: 
        Brasil - BR
        `;
        break;
      case 23:
        hint = `
        A bandeira do cartão deverá ser enviado em código.
        códigos: 

        Visa - 001

        Master - 002

        ELO - 054

        Dinners - 005

        American Express - 003

        Aura - 051

        JCB - 007

        Discover - 004
        
        Hipercard - 050`;
        break;
      case 25:
        hint = `Valor em centavos`
        break;
    }
    return hint;
  }

}
